import React, { useRef } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import FileDropZone, { OpenButtonHandler, ImageTypes } from "components/uiElements/inputs/FileDropZone";

interface SelectAvatarImageProps {
  /**
   * Callback fired when an image file has been selected.
   * @returns The selected file.
   */
  onSelect: (file: File) => void;
}

export default function SelectAvatarImage(props: SelectAvatarImageProps): React.JSX.Element {
  const { i18n } = useTranslation();
  
  const fileDropZoneRef = useRef<OpenButtonHandler>(null);

  async function handleDragDrop(acceptedFiles: Array<File>) {
    const file = acceptedFiles[0];
    props.onSelect(file);
  }

  function handleBrowseFiles() {
    fileDropZoneRef.current?.open();
  }

  return (
    <Stack spacing={1} sx={{
      maxWidth: 420
    }}>
      <Typography variant="body1">
        {i18n.t("select-avatar-image.flavor-text")}
      </Typography>
      <FileDropZone ref={fileDropZoneRef} accept={ImageTypes} onDrop={handleDragDrop}>
        <Stack
          spacing={1}
          sx={{
            padding: 2,
            justifyContent: "center",
            alignItems: "center"
          }}>
          <AccountCircleIcon sx={{fontSize: 96}} />
          <Typography variant="body1">
          <b>{i18n.t("select-avatar-image.instructions-part-1-bolded")}</b> {i18n.t("select-avatar-image.instructions-part-2")}
          </Typography>
          <Box>
            <Button variant="contained" startIcon={<SearchIcon />} onClick={handleBrowseFiles}>{i18n.t("select-avatar-image.browse-button")}</Button>
          </Box>
        </Stack>
      </FileDropZone>
    </Stack>
  );
}